import { generateClient } from "aws-amplify/api";
import { createPoBoxReferal, updatePoBoxReferal, deletePoBoxReferal as removePoBoxReferal } from "graphql/customs/mutations";
import { poBoxReferalsByDate, getPoBoxReferal as fetchPoBoxReferal } from "graphql/queries";
import { cleanUpData, getDataFromResponse, getNotDeletedItems } from "utils/Api";

const API = generateClient();

export const savePoBoxReferal = async (data) => {
    const operationName = (data && data.id) ? "update" : "create";
    const operation = operationName === "update" ? updatePoBoxReferal : createPoBoxReferal;
    let cleanData = cleanUpData(data);

    delete cleanData["referFromPoBox"];
    delete cleanData["referToPoBox"];
    cleanData["type"] = "PoBoxReferal";

    const addressResponse = await API.graphql({
        query: operation,
        variables: {
            "input": cleanData
        }
    });

    return getDataFromResponse(addressResponse, operationName === "create" ? "createPoBoxReferal" : "updatePoBoxReferal");
};

export const getPoBoxReferales = async (filter = {}) => {
    const data = await API.graphql({
        query: poBoxReferalsByDate,
        variables: {
            "filter": filter,
            "type": "PoBoxReferal",
            "sortDirection": "DESC"
        }
    })
    return getNotDeletedItems(data, "poBoxReferalsByDate");
}

export const getPoBoxReferal = async (poBoxRefealId) => {
    let addressObject = await API.graphql({
        query: fetchPoBoxReferal,
        variables: {
            id: poBoxRefealId
        }
    });
    return getDataFromResponse(addressObject, "getPoBoxReferal");
}

export const deletePoBoxReferal = async (addressData) => {
    const deletedAsset = await API.graphql({
        query: removePoBoxReferal,
        variables: {
            input: {
                "id": addressData.id,
            }
        }
    });
    return getDataFromResponse(deletedAsset, "deletePoBoxReferal");
}